var map = {
	"./close.png": 8926,
	"./icon-apibind-active.png": 6302,
	"./icon-apibind.png": 5221,
	"./icon-dashboard-active.png": 3861,
	"./icon-dashboard.png": 1572,
	"./icon-doc-active.png": 2419,
	"./icon-doc.png": 4846,
	"./icon-internet-active.png": 2850,
	"./icon-internet.png": 8145,
	"./icon-matrix-active.png": 7418,
	"./icon-matrix.png": 7497,
	"./icon-task-active.png": 662,
	"./icon-task.png": 9917,
	"./icon-user-active.png": 1448,
	"./icon-user.png": 6827
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9347;